export default __webpack_public_path__ + "static/media/IlonMask.5464c269.png";